import { set } from 'lodash/fp';
import { createReducer } from '@mews/framework';
import { BODY_CELL_SELECTED, SIDEBAR_CLOSED } from '../actionTypes';

const INITIAL_STATE = {
    isOpened: false,
};

const toggleSidebar = set('isOpened');

const sidebarReducer = createReducer(INITIAL_STATE, {
    [BODY_CELL_SELECTED]: toggleSidebar(true),

    [SIDEBAR_CLOSED]: toggleSidebar(false),
});

export default sidebarReducer;
